import { SortInput } from 'components/Table'
import { AdUnitAmazonSortBy } from '../../hooks/useGetAdUnitAmazons'

export const DEFAULT_SORT: SortInput<AdUnitAmazonSortBy> = {
  by: 'path',
  direction: 'asc',
} as const

export const SORTABLE_COLUMNS: AdUnitAmazonSortBy[] = ['divId', 'path', 'updatedAt']
